<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="add"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :total="total"
      :tableData="tableData"
      @pageChange="handleSearch"
      :pageParams="queryParams"
    >
      <template slot="freshPeelMinFairValue" slot-scope="scope">
        <span>{{scope.data.freshPeelMinFairValue}}~{{scope.data.freshPeelMaxFairValue}}</span>
      </template>
      <template slot="dryPeelMinFairValue" slot-scope="scope">
        <span>{{scope.data.dryPeelMinFairValue}}~{{scope.data.dryPeelMaxFairValue}}</span>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':edit']"
          class="button"
          type="text"
          size="small"
          @click="handleUpdata(scope.data, scope.$index)"
        >修改</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="handleSee(scope.data, scope.$index)"
        >详情</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':del']"
          class="delbutton"
          type="text"
          size="small"
          @click="handleDel(scope.data, scope.$index)"
        >删除</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView" :type="type"></component>
      <span slot="footer" v-if="type !=='preview'">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from './Form'
import { mapActions, mapState } from 'vuex'
// import { getRegiontList, getRegiontDetail, delregion } from '@/api/library/vallage'
import { getReasonableList, reasonableDelete, reasonableQueryById } from '@/api/system/reasonable'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
  },
  data() {
    return {
      authIdentity: 'system:reasonable',
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      type: '',
      colLists: [
        {
          prop: 'ripenessLevelSpecAttrValueKey',
          label: '成熟度',
          isTrue: true,
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄',
          isTrue: true,
        },
        {
          prop: 'freshPeelMinFairValue',
          label: '鲜皮率(%)',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'dryPeelMinFairValue',
          label: '干皮出皮率(%)',
          isTrue: true,
          formSolt: true,
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      tableData: [{ code: 'xx' }],
      selectOrInputList: [
        {
          model: 'ripenesslvlSpecValKeyList',
          placeholder: '请选择成熟度',
          value: 'dictValue',
          label: 'dictLabel',
          list: [],
          type: 'select',
        },
        {
          model: 'cropAgeValue',
          placeholder: '请选择树龄',
          value: 'dictValue',
          label: 'dictLabel',
          list: [],
          type: 'select',
        },
      ],
    }
  },
  created() {
    this.getDictList({ types: 'treeAge,ripenessLevel' })
    this.getReasonableList()
  },
  computed: {
    ...mapState({
      treeAge: (state) => (state.system.dictList && state.system.dictList.treeAge) || [],
      ripenessLevel: (state) => (state.system.dictList && state.system.dictList.ripenessLevel) || [],
    }),
  },
  watch: {
    ripenessLevel: {
      handler(newVal) {
        this.selectOrInputList[0].list = newVal
      },
    },
    treeAge: {
      handler(newVal) {
        this.selectOrInputList[1].list = newVal
      },
    },
  },
  methods: {
    ...mapActions({ getDictList: 'system/getDictList' }),
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          reasonableDelete(row.id).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`操作成功！`)
              this.getReasonableList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    submitFrom() {
      console.log('进来')
      this.$refs.myform.submit(this.type, (data) => {
        console.log(data, '-------------------')

        if (data) {
          this.dialogVisible = false
          this.getReasonableList()
        }
      })
    },
    cancel() {
      this.$refs.myform.reset()
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '新增合理值范围'

        this.type = 'add'
        this.$refs.myform.add(this.type)
      })
    },
    handleSee(row) {
      reasonableQueryById(row.id)
        .then((res) => {
          if (res.flag) {
            let data = res.data
            this.dialogVisible = true
            this.title = '查看'
            this.currentView = 'myform'
            this.type = 'preview'
            this.$nextTick(() => {
              this.$refs.myform.getDetail(data, this.type)
            })
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleUpdata(row) {
      reasonableQueryById(row.id)
        .then((res) => {
          if (res.flag) {
            let data = res.data
            this.dialogVisible = true
            this.currentView = 'myform'
            this.type = 'edit'
            this.title = '修改'
            this.$nextTick(() => {
              this.$refs.myform.getDetail(data)
            })
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })

      // this.$nextTick(() => {
      //   this.title = '修改行政区域管理'
      //   console.log(that.$refs.myform, ' this.$refs.my111111111111form.getDetail------------')
      //   this.$refs.myform.getDetail(row)

      //   this.type = 'edit'
      // })
    },
    handleFence(row) {
      console.log('围明细')
      console.log(row, 'row')
      this.$router.push({
        path: '/fence',
        query: {
          parentId: row.id,
          name: row.name,
          parentFullName: row.parentFullName,
          parentFullCodeList: row.parentFullCodeList,
          code: row.code,
        },
      })
    },
    getReasonableList() {
      getReasonableList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items
            this.total = res.data.totalCount
            console.log(this.tableData, 'this.tableDatathis.tableData--------------')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleSearch(data) {
      console.log(data, '----------------------')
      if (data) {
        for (let key in data) {
          this.queryParams[key] = data[key]
        }
      }

      this.getReasonableList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
      }
      this.getReasonableList()
    },
  },
}
</script>
<style scoped lang='less'>
@import '~@/assets/tableList.less';
// @import '../../../../assets/form.less';
::v-deep {
  input[type='number'] {
    -moz-appearance: textfield; /* Firefox */
    appearance: textfield;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none; /* Safari */
    margin: 0;
  }
}
/deep/ .el-button--text {
  font-size: 14px;
}
</style>